// extracted by css-extract-rspack-plugin
export default {"modifiedDownloadCompletedForm":"eQQUR7KKPEk7Ox88","para":"TQ7UUyaoEPbRQKx_"};